import { Component, OnInit,Input } from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets} from 'chart.js';
import { MultiDataSet, Label,PluginServiceGlobalRegistrationAndOptions } from 'ng2-charts';
@Component({
  selector: 'app-graficabarra',
  templateUrl: './graficabarra.component.html',
  styleUrls: ['./graficabarra.component.scss']
})
export class GraficabarraComponent implements OnInit {
@Input('conocimiento') conocimiento: number;
@Input('satisfaccion') satisfaccion: number;

resultadoConocimiento:string;
resultadoSatisfaccion:string;


  barChartOptions: ChartOptions;
  barChartLabels: Label[] = [];
  barChartType: ChartType = 'bar';
  barChartLegend = true;
  barChartData : ChartDataSets[];


  constructor() { }

  ngOnInit() {
    this.graficaDemograficos();

  }



  graficaDemograficos(){
    console.log('this.conocimiento',this.conocimiento);
    console.log('this.satisfaccion',this.satisfaccion);


    this.resultadoConocimiento=this.conocimiento.toFixed(2);
    this.resultadoSatisfaccion=this.satisfaccion.toFixed(2);
    this.barChartOptions= {
      responsive: true,
      legend: {
   display: false,
     },
      tooltips: {
        enabled: false },
          // We use these empty structures as placeholders for dynamic theming.
      scales: {
        xAxes: [{
        ticks:{
          min: 0,
          max: 100,
        }}],
        yAxes: [{
        ticks:{
          display: false,
          min: 0,
          max: 100,

        }
      }] },
      plugins: {
        datalabels: {
          display:true,
          anchor: 'end',
          align: 'end',
        }
      },
          animation: {
       onComplete: function () {
         const chartInstance = this.chart,
           ctx = chartInstance.ctx;

          ctx.font = ' 15px Arial';
         // ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

         ctx.textAlign = 'center';
         ctx.textBaseline = 'middle';
         ctx.fillStyle = 'white';
         ctx.hover="null";

         this.data.datasets.forEach(function (dataset, i) {
           const meta = chartInstance.controller.getDatasetMeta(i);
           meta.data.forEach(function (bar, index) {
             if (dataset.data[index] !== 0) {
               const data = dataset.data[index].toLocaleString('it-IT');
               ctx.fillText(data+'%', bar._model.x, bar._model.y +10);
             }
           });
         });
       }
      },
      hover: {
           animationDuration: 0 // duration of animations when hovering an item
       },
    };

     this.barChartData= [
      { data: [Number(this.resultadoConocimiento)],
        label:'conocimiento',
        backgroundColor: ["#087272"],
        hoverBackgroundColor: ["#087272"],
        borderColor: ["#087272"],
        },

      { data: [Number(this.resultadoSatisfaccion)],
        label:'Satisfacccion',
        backgroundColor: ["#FF613A"],
        hoverBackgroundColor: ["#FF613A"],
        borderColor: ["#FF613A"],
      }
    ];


  }

}
